// with polyfills
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/'
import { VueAxios } from './utils/request'
import '@/core/directives/cc'
import '@/core/directives/permissionBut'
// mock
// WARNING: `mockjs` NOT SUPPORT `IE` PLEASE DO NOT USE IN `production` ENV.
// import './mock'

// import bootstrap from './core/bootstrap'
import './core/lazy_use'
// 路由权限
import './permission' // permission control
import './utils/filter' // global filter
import './components/global.less'
import Vant from 'vant'
import 'vant/lib/index.css'
import './utils/setRem'
import { Dialog } from '@/components'

import vueSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import HappyScroll from 'vue-happy-scroll'
import 'vue-happy-scroll/docs/happy-scroll.css'
// 引入vue-i18n包
import VueI18n from 'vue-i18n'
import zh from './lang/zh'
import en from './lang/en'
// 创建vuei18n实例（两个配置项:locale，messages）
Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || 'en',
  // 配置语言文件对象
  messages: {
    'zh': zh,
    'en': en
  }
})

Vue.prototype.ppPay = window.ppPay

Vue.config.productionTip = false

Vue.use(HappyScroll)
Vue.use(vueSwiper)
// mount axios Vue.$http and this.$http
Vue.use(VueAxios)
Vue.use(Dialog)
Vue.use(Vant)

new Vue({
  router,
  store,
  i18n,
  // created: bootstrap,
  render: h => h(App)
}).$mount('#app')
